module.exports = __webpack_public_path__ + "static/media/oSkutecznejKomunikacji.49653895.png";